var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","sm":"12"}},[_c('h2',[_vm._v("Home")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }